import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BROWSER_ROUTES } from "@constants/browser.routes";
import { broadcastLogoutToOtherTabs } from "@utils/authCrossTabBroadcast";
import { logoutSessionInStore } from "@utils/logoutSessionInStore";

export const useLogout = () => {
	const navigate = useNavigate();
	const [showLogoutModal, setShowLogoutModal] = useState(false);

	const handleLogoutClick = () => {
		setShowLogoutModal(true);
	};

	const handleLogoutConfirm = () => {
		logoutSessionInStore();
		broadcastLogoutToOtherTabs();
		navigate(BROWSER_ROUTES.DASHBOARD);
		setShowLogoutModal(false);
	};

	const handleLogoutCancel = () => {
		setShowLogoutModal(false);
	};

	return {
		handleLogout: handleLogoutClick,
		handleLogoutConfirm,
		handleLogoutCancel,
		showLogoutModal,
	};
};
